/* eslint-disable import/prefer-default-export */

import { http } from './fetch-wrapper';
import { apiUrls } from './index';

export function auth({ authData, params }) {
  const headers = new Headers();

  headers.append('Authorization', authData);
  headers.append('Content-Type', 'application/json');

  const requestOptions = {
    headers,
    method: 'POST',
    body: JSON.stringify(params),
  };

  return http(apiUrls.AUTH, requestOptions);
}



// WEBPACK FOOTER //
// ./api/authorization.js